import AssignmentsStats from "./AssignmentsStats";

export default AssignmentsStats;
